module.exports = __webpack_public_path__ + "img/photo-60.30ce3b53.png";